import React from "react";
import { TRANSACTION_TYPES } from "../utils/constants";

const getTransactionIcon = (type) => {
  const icons = {
    "Delivery": "bi-truck",
    "Dine In": "bi-person-workspace",
    "Take Out": "bi-bag-check",
    "GrabFood": "bi-app",
    "FoodPanda": "bi-box-seam",
    "Pick Up": "bi-hand-index",
    "Del Time": "bi-clock-history",
    "Drive-thru": "bi-car-front",
    "Tablevibe": "bi-tablet",
    "undefined": "bi-question-circle",
  };
  return icons[type] || "bi-receipt";
};

const TransactionDetails = ({ storeData, totalNet, totals, voidTotals }) => {
  const currencyFormatter = new Intl.NumberFormat("en-PH", {
    style: "currency",
    currency: "PHP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div>
      <h6 
        style={{ 
          color: "#111827",
          fontSize: "0.9375rem",
          fontWeight: "700",
          marginBottom: "16px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <i className="bi bi-receipt-cutoff" style={{ color: "#83c14a" }}></i>
        Transaction Breakdown
      </h6>

      <div className="row g-3">
        {TRANSACTION_TYPES.map((type) => {
          const typeData = storeData[type] || {};
          const netSale = typeData.netSale || 0;
          const transactionCount = typeData.tc || 0;
          const percentageOfTotal = totalNet > 0 ? (netSale / totalNet) * 100 : 0;
          const hasData = netSale > 0 || transactionCount > 0;

          return (
            <div className="col-md-6 col-lg-4" key={type}>
              <div 
                style={{
                  background: hasData ? "#FFFFFF" : "#F9FAFB",
                  borderRadius: "10px",
                  padding: "16px",
                  border: `1px solid ${hasData ? "#E5E7EB" : "#F3F4F6"}`,
                  height: "100%",
                  transition: "all 0.2s ease",
                  opacity: hasData ? 1 : 0.6,
                }}
                onMouseEnter={(e) => {
                  if (hasData) {
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.08)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                  <div 
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "8px",
                      background: hasData ? "#F0FDF4" : "#F3F4F6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "10px",
                    }}
                  >
                    <i 
                      className={getTransactionIcon(type)} 
                      style={{ 
                        fontSize: "1.125rem", 
                        color: hasData ? "#83c14a" : "#9CA3AF" 
                      }}
                    ></i>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      fontSize: "0.8125rem", 
                      fontWeight: "600", 
                      color: hasData ? "#374151" : "#9CA3AF",
                      marginBottom: "2px",
                    }}>
                      {type}
                    </div>
                    <div style={{ 
                      fontSize: "1.125rem", 
                      fontWeight: "700", 
                      color: hasData ? "#059669" : "#D1D5DB" 
                    }}>
                      {currencyFormatter.format(netSale)}
                    </div>
                  </div>
                </div>

                <div style={{ 
                  display: "flex", 
                  justifyContent: "space-between",
                  marginBottom: "8px",
                }}>
                  <div>
                    <div style={{ fontSize: "0.6875rem", color: "#9CA3AF", fontWeight: "600" }}>
                      COUNT
                    </div>
                    <div style={{ fontSize: "0.875rem", fontWeight: "600", color: "#374151" }}>
                      {transactionCount.toLocaleString()}
                    </div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: "0.6875rem", color: "#9CA3AF", fontWeight: "600" }}>
                      SHARE
                    </div>
                    <div style={{ 
                      fontSize: "0.875rem", 
                      fontWeight: "700", 
                      color: hasData ? "#83c14a" : "#D1D5DB" 
                    }}>
                      {isNaN(percentageOfTotal) ? "0%" : `${percentageOfTotal.toFixed(2)}%`}
                    </div>
                  </div>
                </div>

                <div style={{ 
                  width: "100%", 
                  height: "4px", 
                  background: "#E5E7EB", 
                  borderRadius: "2px",
                  overflow: "hidden",
                }}>
                  <div 
                    style={{ 
                      width: `${Math.min(percentageOfTotal, 100)}%`,
                      height: "100%",
                      background: hasData 
                        ? "linear-gradient(90deg, #83c14a 0%, #6fa83e 100%)" 
                        : "#D1D5DB",
                      transition: "width 0.5s ease",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransactionDetails;
